import axios from "axios";
import { getToken } from "../utils/auth";
import CONFIG from "../config";

const baseURL = CONFIG.baseURL;

const api = axios.create({
  baseURL
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    } else if (err.response?.status === 403) {
      window.location.href = "/unauthrized";
    } else if (err.response?.status === 404) {
      window.location.href = "/404";
    }
    return Promise.reject(err);
  }
);

export const AuthAPI = {
  checkIP: () => api.get("/auth/check-ip")
}

export const TaskAPI = {
  getAll: () => api.get("/tasks"),
  getById: (id) => api.get(`/tasks/${id}`),
  create: (task) => api.post("/tasks", task),
  update: (id, task) => api.put(`/tasks/${id}`, task),
  delete: (id) => api.delete(`/tasks/${id}`),
  aprrove: (payload) => api.put(`/tasks/approve`, payload)
};

export const PlaylistsAPI = {
  getAll: () => api.get("/playlists"),
  getPlaylists: () => api.get("/playlists/check-playlist"),
  getById: (id) => api.get(`/playlists/${id}`),
  create: (payload) => api.post("/playlists/create", payload),
  update: (payload) => api.post(`/playlists/update`, payload, {
    headers: { "Content-Type": "application/json" },
  }),
  delete: (id) => api.delete(`/playlists/${id}`),
  getFolders: () => api.get("/playlists/folders"),
  addFolder: (payload) => api.post(`/playlists/add-folder`, payload),
  browse: () => api.get("/playlists/browse"),
  addFile: (payload) => api.post("/playlists/add-file", payload),
  removeTrack: (id) => api.post("/playlists/remove-track", id, {
    headers: { "Content-Type": "application/json" },
  })
};

export const WhitelistAPI = {
  getAll: () => api.get("/WhitelistIPs"),
  get: (id) => api.get(`/WhitelistIPs/${id}`),
  create: (data) => api.post("/WhitelistIPs", data),
  update: (id, data) => api.put(`/WhitelistIPs/${id}`, data),
  delete: (id) => api.delete(`/WhitelistIPs/${id}`)
};

export default api;
